import { VerifyMethodType } from "shared/types";
import { AdditionalData } from "../../types/verified/bank-statment";

const getGenericRejectionChecks = (
  additionalData: AdditionalData | null,
  documentType: VerifyMethodType
) => [
  {
    condition: additionalData?.type_mismatch,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: `The document is not a ${documentType?.replaceAll("_", " ")}`
    }
  },
  {
    condition: additionalData?.is_fraudulent,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "Fraudulent activity detected"
    }
  },
  {
    condition: additionalData?.high_risk_level,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "High risk level"
    }
  },
  {
    condition: additionalData?.low_trust_score,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "Low trust score"
    }
  },
  {
    condition: additionalData?.low_quality_score,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "The file is of poor quality"
    }
  },
  {
    condition: additionalData?.is_name_present === false,
    reasonCode: {
      code: "",
      confidence: "HIGH",
      description: "No name present on document"
    }
  }
];

// For any document verified through Inscribe
export const getGenericReasonCodes = (
  additionalData: AdditionalData,
  documentType: VerifyMethodType
) => {
  const rejectionChecks = getGenericRejectionChecks(
    additionalData,
    documentType
  );

  const reasonCodes = rejectionChecks
    .filter((check) => check.condition)
    .map((check) => check.reasonCode);

  return reasonCodes;
};
